module.exports = "/assets/d544353296825f109861559ce2dae716.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HR.png
// module id = 1449
// module chunks = 0